import React, { useCallback, useMemo } from "react";

import { useI18n } from "../../../../hooks/i18n-hooks";

import VStack from "../../../../ui_atoms/VStack";
import ScreenCard, { ButtonType } from "../../../../screens/ScreenCard";

import { StackScreenProps } from "@react-navigation/stack";
import { IJMEditorStackParamList } from "../IJMEditorNavigator";
import { useRecoilState } from "recoil";
import { editIjmSelection } from "../../../../atoms/core";
import ListItem from "../../../../ui_atoms/ListItem";
import { getPayFirstDaysChoices } from "../helper";
import { BodyMediumText, TitleMediumText } from "../../../FormattedText";
import Gap from "../../../../ui_atoms/Gap";
import Separator from "../../../../ui_atoms/separator";

type WaitingSelectScreenProps = StackScreenProps<IJMEditorStackParamList, "WaitingSelect">;

const WaitingSelectScreen: React.FC<WaitingSelectScreenProps> = ({ navigation }) => {
    const i18n = useI18n();
    const [ijmSelection, setIjmSelection] = useRecoilState(editIjmSelection);

    const onCancel = useCallback(() => {
        navigation.goBack();
    }, [navigation]);

    const ijmChoices = useMemo(() => {
        return getPayFirstDaysChoices().map((x) => ({
            label: i18n.t(x.label),
            value: x.value,
        }));
    }, [i18n]);

    const buttons = useMemo<ButtonType[]>(() => {
        return [
            {
                title: i18n.t("close"),
                onPress: onCancel,
                mode: "outlined",
                isValid: true,
            },
        ];
    }, [i18n, onCancel]);

    return (
        <ScreenCard buttons={buttons}>
            <VStack>
                <Gap gap={0.5} />
                <VStack h="2/3">
                    <TitleMediumText>{i18n.t("ijm.editor.waiting_select.title")}</TitleMediumText>
                    <Gap gap={1} />
                    <BodyMediumText>{i18n.t("ijm.editor.waiting_select.text_1")}</BodyMediumText>
                    <Gap gap={1} />
                    <TitleMediumText>{i18n.t("ijm.editor.waiting_select.title_2")}</TitleMediumText>
                </VStack>
                <Separator top={1 / 2} />
                {ijmChoices.map((ijmChoice) => (
                    <ListItem
                        key={`${ijmChoice.value}`}
                        title={ijmChoice.label}
                        selectable
                        checked={ijmChoice.value === ijmSelection.ijmPayFirstDays}
                        onPress={() => {
                            setIjmSelection((prev) => ({
                                ...prev,
                                ijmPayFirstDays: ijmChoice.value,
                            }));
                            navigation.goBack();
                        }}
                    />
                ))}
            </VStack>
        </ScreenCard>
    );
};

export default WaitingSelectScreen;
